export const GUIDELINE_ADD = 'GUIDELINE_ADD';
export const GUIDELINE_UPDATE = 'GUIDELINE_UPDATE';
export const GUIDELINE_SILENCE_UPDATE = 'GUIDELINE_SILENCE_UPDATE';
export const GUIDELINE_FINAL_PUBLICATION = 'GUIDELINE_FINAL_PUBLICATION';
export const GUIDELINE_CHANGE_PHASE = 'GUIDELINE_CHANGE_PHASE';
export const GUIDELINE_DELETE = 'GUIDELINE_DELETE';
export const GUIDELINE_DELETE_FILE_BY_ID = 'GUIDELINE_DELETE_FILE_BY_ID';
export const GUIDELINE_LIST_PHASES_BY_ID = 'GUIDELINE_LIST_PHASES_BY_ID';
export const GUIDELINE_UPDATE_DEADLINE = 'GUIDELINE_UPDATE_DEADLINE';
export const GUIDELINE_UPDATE_COI = 'GUIDELINE_UPDATE_COI';
export const GUIDELINE_ADMIN_UPLOAD_APPROVE = 'GUIDELINE_ADMIN_UPLOAD_APPROVE';

export const GUIDELINE_SET_QUERY = 'GUIDELINE_SET_QUERY';

export const GUIDELINE_REQUEST = 'GUIDELINE_REQUEST';
export const GUIDELINE_REQUEST_BY_ID = 'GUIDELINE_REQUEST_BY_ID';
export const GUIDELINES_REQUEST = 'GUIDELINES_REQUEST';
export const GUIDELINE_REJECT = 'GUIDELINE_REJECT';
export const GUIDELINE_CLOSE_UPLOAD = 'GUIDELINE_CLOSE_UPLOAD';
export const GUIDELINE_CLOSE_UPLOAD_REVIEW_USER_PHASE = 'GUIDELINE_CLOSE_UPLOAD_REVIEW_USER_PHASE';
export const GUIDELINE_FORMAL_CHECK_APPROVAL = 'GUIDELINE_FORMAL_CHECK_APPROVAL';
export const GUIDELINE_SUBMIT_NATIONAL_DELEGATE_REVIEW = 'GUIDELINE_SUBMIT_NATIONAL_DELEGATE_REVIEW';
export const GUIDELINES_SUCCESS = 'GUIDELINES_SUCCESS';
export const GUIDELINES_ERROR = 'GUIDELINES_ERROR';
export const GUIDELINES_EMPTY = 'GUIDELINES_EMPTY';
export const GUIDELINES_FILTER_DRAFT = 'GUIDELINES_FILTER_DRAFT';
